/**
 * 诊室模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增医疗设备
export const save = (params) => {
    return req.post('/treatDevice/save', params);
}
// 列表
export const list = (params) => {
    return req.post('/treatDevice/list', params);
}
// 删除
export const remove = (params) => {
    return req.post('/treatDevice/delete', params);
}